import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    Renderer2,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import Croppie from 'croppie';
import {CroppieOptions} from 'croppie';

@Component({
    selector: 'app-profile-image-selector',
    templateUrl: './profile-image-selector.component.html',
    styleUrls: ['./profile-image-selector.component.scss'],
    standalone: false
})
export class ProfileImageSelectorComponent implements AfterViewInit, OnChanges, OnDestroy {

    @Input()
    src: string;

    @Output()
    srcChange = new EventEmitter();

    @ViewChild('imageEditor')
    imageEditor: ElementRef;

    @ViewChild('input')
    input: ElementRef;

    @ViewChild('croppie')
    croppieEl: ElementRef;

    public croppieOptions: CroppieOptions = {
        viewport: {width: 134, height: 134, type: 'circle'},
        boundary: {width: 134, height: 134},
        showZoomer: false,
        enableOrientation: true
    };
    private croppieInstance: Croppie;
    private $cropContainer: HTMLElement;

    constructor(private renderer: Renderer2) {
    }

    ngAfterViewInit() {
        const $imageEditor = this.imageEditor.nativeElement as HTMLElement;
        this.$cropContainer = $imageEditor.querySelector<HTMLElement>('.croppie-container');
        this.croppieInstance = new Croppie(this.croppieEl.nativeElement, this.croppieOptions);
        this.initCropper();
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('src' in changes) {
            if (this.input) {
                this.input.nativeElement.value = '';
            }
            this.resetCropper();
        }
    }

    ngOnDestroy() {
        if (this.croppieInstance) {
            this.croppieInstance.destroy();
        }
    }

    loadProfileImage(files: FileList) {
        if (!files || files.length !== 1) {
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            this.src = e.target.result as string;
            this.srcChange.emit(e.target.result);
            this.resetCropper();

            this.croppieInstance.bind({url: this.src});
        };

        reader.readAsDataURL(files[0]);
    }

    removeProfileImage() {
        this.input.nativeElement.value = '';
        this.src = '';
        this.srcChange.emit('');
        this.resetCropper();
    }

    async croppedImage(): Promise<any> {
        return this.croppieInstance.result({
            type: 'base64',
            format: 'png'
        });
    }

    private resetCropper(position?: object) {
        if (this.croppieInstance) {
            if (this.src) {
                this.$cropContainer.setAttribute('tabindex', '0');
            } else {
                this.$cropContainer.removeAttribute('tabindex');
            }
        }
    }

    private initCropper() {
        if (this.src) {
            this.croppieInstance.bind({url: this.src});
        }
    }
}
